import raw from './logo-ascii.txt'

export const logoArt = () => {
    try {
        
        fetch(raw)
        .then(r => r.text())
        .then(text => {
            console.log("INGENIA REST")
            // console.log(text);
        })
    } catch (e) {
        console.log(e)
    }
}